import { useState } from "react";
import { observer } from "mobx-react";
import errorIcon from '../../../assets/images/error-icon.svg';
import { utilsStore } from "../../../platform/stores";
import { useTranslation } from "../../../platform/stores/translationStore";
import './ConnectionLostModal.scss';

// Blocks the game until the player reconnects: with a lost session every bet would fail anyway.
export const ConnectionLostModal = observer(() => {
  const { connectionLost } = utilsStore;
  const [reconnecting, setReconnecting] = useState(false);
  const t = useTranslation();

  if (!connectionLost) return null;

  const reconnect = () => {
    setReconnecting(true);
    window.location.reload();
  };

  return (
    <div className="connection-lost-overlay" role="alertdialog" aria-modal="true" aria-labelledby="connection-lost-title">
      <div className="connection-lost-backdrop"/>
      <div className="connection-lost-card">
        <img className="connection-lost-icon" src={errorIcon} alt=""/>
        <h2 id="connection-lost-title">{t(connectionLost.title ?? 'CONNECTION_LOST')}</h2>
        <p className="connection-lost-message">{t(connectionLost.message)}</p>
        {connectionLost.canReconnect && (
          <button className="connection-lost-btn" onClick={reconnect} disabled={reconnecting}>
            {t('RECONNECT')}
          </button>
        )}
        {/* Quiet enough for players to ignore; tells developers which failure a screenshot shows and when. Codes are listed in README.md. */}
        <div className="connection-lost-code">
          <div>{connectionLost.code}</div>
          <div>{connectionLost.time.toISOString().slice(0, 19).replace('T', ' ')} UTC</div>
        </div>
      </div>
    </div>
  );
});
